export function getContrastColor(bgColor) {
  if (bgColor === undefined) {
    return "#000000";
  }

  if (bgColor === "transparent") {
    return "#000000";
  }

  // If bg Color not hex return black
  if (!bgColor.match(/^#(?:[0-9a-fA-F]{3}){1,2}$/)) {
    return "#000000";
  }

  // Convert HEX to RGB if needed
  let r, g, b;

  if (bgColor.startsWith("#")) {
    const hex = bgColor.replace("#", "");
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    }
  } else {
    [r, g, b] = bgColor.match(/\d+/g).map(Number); // Extract RGB values from `rgb(r,g,b)`
  }

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return white for dark backgrounds, black for light backgrounds
  return luminance > 0.5 ? "#000000" : "#FFFFFF";
}
